export const replaceSubTypes = (para, val, replaceVal) => JSON.parse(JSON.stringify(para).replaceAll(val, replaceVal));

export const simplifyToolsData = (tools) => {
  const arr = [];

  tools.content.forEach((tool) => {
    arr.push(tool.content[0].attrs);
  });

  if (arr.length === 0) {
    return undefined;
  }

  return arr;
};
